import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Button } from '../components/ui/Button';
import { SectionHeading } from '../components/ui/SectionHeading';
export function About() {
  return <div className="bg-ivory" data-id="element-64">
      {/* Hero Section */}
      <section className="relative h-[70vh] min-h-[500px] flex items-center justify-center overflow-hidden" data-id="element-65">
        <div className="absolute inset-0 z-0" data-id="element-66">
          <img src="https://images.unsplash.com/photo-1515377905703-c4788e51af15?q=80&w=2000&auto=format&fit=crop" alt="Soft aesthetic beauty portrait" className="w-full h-full object-cover object-center" data-id="element-67" />
          <div className="absolute inset-0 bg-espresso/30 mix-blend-multiply" data-id="element-68" />
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-69">
          <FadeIn delay={0.2} data-id="element-70">
            <h1 className="text-5xl md:text-7xl text-ivory mb-6 text-balance" data-id="element-71">
              About Aura Beauty Atelier
            </h1>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-72">
            <p className="text-lg md:text-xl text-cream font-light text-balance" data-id="element-73">
              A refined beauty experience, created with intention.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 md:py-32 px-6" data-id="element-74">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-75">
          <FadeIn direction="right" data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/7aV9VKHbPhT9f9yW8r3h4H/Screenshot_2026-06-09_at_10.05.55_PM.png" alt="Founder of Aura Beauty Atelier in Charlotte, NC" className="w-full aspect-[3/4] object-cover object-top" data-id="element-77" />
          </FadeIn>
          <FadeIn direction="left" className="max-w-xl" data-id="element-78">
            <SectionHeading title="Our Story" centered={false} data-id="element-79" />
            <div className="space-y-6 text-lg text-taupe font-light leading-relaxed mt-8" data-id="element-80">
              <p data-id="element-81">
                Aura Beauty Atelier was created for brides and women who desire
                more than beautiful results — they desire an experience that
                feels elevated, calming, and deeply considered.
              </p>
              <p data-id="element-82">
                Rooted in soft glam artistry and luxury on-site service, Aura
                blends beauty, convenience, and care into an experience that
                feels polished from beginning to end.
              </p>
              <p data-id="element-83">
                Every detail is designed to enhance your natural beauty while
                allowing you to feel confident, radiant, and completely at ease.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-24 bg-cream px-6" data-id="element-84">
        <div className="max-w-4xl mx-auto text-center" data-id="element-85">
          <FadeIn data-id="element-86">
            <SectionHeading title="Our Philosophy" data-id="element-87" />

            <div className="my-16 space-y-6" data-id="element-88">
              <h3 className="text-3xl md:text-4xl text-espresso italic font-serif" data-id="element-89">
                "Beauty should feel effortless."
              </h3>
              <h3 className="text-3xl md:text-4xl text-espresso italic font-serif" data-id="element-90">
                "Luxurious."
              </h3>
              <h3 className="text-3xl md:text-4xl text-espresso italic font-serif" data-id="element-91">
                "Intentional."
              </h3>
            </div>

            <p className="text-lg text-taupe font-light leading-relaxed max-w-2xl mx-auto" data-id="element-92">
              At Aura, every service is thoughtfully curated to deliver refined
              artistry, personalized attention, and a sense of calm that
              transforms beauty into experience.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 md:py-32 px-6" data-id="element-93">
        <div className="max-w-7xl mx-auto" data-id="element-94">
          <FadeIn data-id="element-95">
            <SectionHeading title="The Aura Experience" data-id="element-96" />
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mt-16" data-id="element-97">
            {['Luxury brought on-site', 'Refined soft glam artistry', 'Personalized beauty rituals', 'Calm, detail-driven service', 'Elevated care from start to finish'].map((value, i) => <FadeIn key={i} delay={i * 0.1} className="bg-white border border-champagne/50 p-8 text-center flex items-center justify-center min-h-[200px]" data-id="element-98">
                <p className="text-espresso font-serif text-xl leading-snug" data-id="element-99">
                  {value}
                </p>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-espresso text-center px-6" data-id="element-100">
        <FadeIn data-id="element-101">
          <h2 className="text-3xl md:text-4xl font-serif text-ivory mb-8" data-id="element-102">
            Ready to experience Aura?
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-103">
            <Button href="/contact" variant="primary" className="bg-ivory text-espresso hover:bg-cream" data-id="element-104">
              Inquire Now
            </Button>
            <Button href="/beauty-services" variant="outline" className="border-ivory text-ivory hover:bg-ivory hover:text-espresso" data-id="element-105">
              Explore Services
            </Button>
          </div>
        </FadeIn>
      </section>
    </div>;
}